@if(hasUser && messagesEnabled){
<div class="m-0 mt-2 col-lg-11 row align-items-center">
    <ul class="nav nav-tabs m-0 px-3">
        <li class="nav-item">
            <a class="nav-link" [ngClass]="{ 'active': isRiskProfile }" [routerLink]="'/dashboard'">{{ 'si_pts_chrome_tabs_risk_profile' | cmsText | async }}</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [ngClass]="{ 'active': isMessages }" [routerLink]="'/messages'">
                <span class="me-2">{{ 'si_pts_chrome_tabs_messages' | cmsText | async }}</span>
                @if(messageCount){
                <span class="badge rounded-pill text-light" [ngClass]="{ 'text-bg-dark': isMessages, 'text-bg-primary': isRiskProfile }">{{ messageCount }}</span>
                }
            </a>
        </li>
    </ul>
</div>
}
